import PropTypes from 'prop-types';

const ChildrenRule = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);

export default { ChildrenRule };
